















import { VTabs, VTabsItems, VTabItem, VTab } from 'vuetify/lib'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-tabs',
  components: {
    VTabs,
    VTab,
    VTabsItems,
    VTabItem
  },
  props: {
    value: Number,
    items: Array,
    sliderSize: {
      type: Number,
      default: 4
    }
  }
})
